import { ChartMultilineIcon } from './ChartMultilineIcon';

/**
 * author: Google
 * id 746FB7AE-B8AC-4356-8B79-D95F54B410D7
 * name chart-multiline
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-multiline.svg
 * tags
 * - Math 
 */
export const ReportMultilineIcon = ChartMultilineIcon;
export default ReportMultilineIcon